module.exports = __webpack_public_path__ + "img/Icon-LOC.527bea84.png";